module.exports = __webpack_public_path__ + "img/shop-and-service-filter-navy.5436fdc7.png";